import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../../../common/models/httpError";
import {ValidatedValue} from "../../../../../../helpers/validatedValue";
import React from "react";
import i18n from "i18next";
import {Popup} from "../../../../../../common/components/shared/popup/popup";
import {HttpError} from "../../../../../../common/components/shared/httpError/httpError";
import {Api} from "../../../../../../helpers/api";
import {AvailableSupervisorActions, SupervisorFlowAction} from "../../../../../models/order";
import DropDown from "../../../../../../common/components/shared/dropDown/dropDown";
import {DropDownModel} from "../../../../../../common/models/dropDown";
import {DropDownUtils} from "../../../../../../helpers/dropDownUtils";
import "./changeStatusPopup.scss";
import {TransportationService} from "../../../../../services/transportationService";

interface ChangeStatusPopupProps {
    displayPopup: boolean;
    closePopup: () => void;
    onChangeDropdown: (newValue: SupervisorFlowAction) => void;
    confirm: () => void;
    orderId: string;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    selectedAction: ValidatedValue<SupervisorFlowAction | null>;
    isWaiting: boolean;
}

interface ChangeStatusPopupState {
    availableSupervisorFlowAction: AvailableSupervisorActions | undefined;
    availableActionResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class ChangeStatusPopup extends React.Component <ChangeStatusPopupProps, ChangeStatusPopupState> {
    constructor(props: ChangeStatusPopupProps) {
        super(props);

        this.state = {
            availableSupervisorFlowAction: undefined,
            availableActionResponse: undefined
        };
    }

    async componentDidMount() {
        const availableActionResponse = await TransportationService.getAvailableActions(this.props.orderId);

        this.setState({
            availableSupervisorFlowAction: (Api.isSuccess(availableActionResponse) && availableActionResponse?.data) ? availableActionResponse?.data : undefined,
            availableActionResponse
        });
    }

    render() {
        return (
            <Popup
                open={this.props.displayPopup}
                className="change-status-popup"
                header={i18n.t("transportation.order.status.supervisorFlowActionsPopup.header")}
                secondHeader={i18n.t("transportation.order.status.supervisorFlowActionsPopup.header")}
                content={this.renderContent()}
                actionText={i18n.t("transportation.order.status.supervisorFlowActionsPopup.actionText")}
                action={this.props.confirm}
                cancel={this.props.closePopup}
                isWaiting={this.props.isWaiting}
                testId="change-status-popup"
                httpError={
                    <>
                        {!Api.isSuccess(this.props.response) && (
                            <HttpError
                                response={this.props.response}
                                cause={i18n.t("transportation.order.status.supervisorFlowActionsPopup.executeChangeStatusErrorSuffix")}
                            />
                        )}
                        {!Api.isSuccess(this.state.availableActionResponse) && (
                            <HttpError
                                response={this.state.availableActionResponse}
                                cause={i18n.t("transportation.order.status.supervisorFlowActionsPopup.availableStatusesErrorSuffix")}
                            />
                        )}
                    </>
                }
            />
        );
    }

    private renderContent() {
        return (
            <div className="change-status-popup-content">
                {i18n.t("transportation.order.status.supervisorFlowActionsPopup.content")} <b>{this.props.orderId}</b>?
                <DropDown
                    className="selected-status"
                    label={i18n.t("transportation.order.status.supervisorFlowActionsPopup.label")}
                    validatedValue={this.props.selectedAction}
                    items={this.actionsToDropDownMap()}
                    testId="change-status"
                    onChange={this.props.onChangeDropdown}
                    withEmptyValue
                />
            </div>
        );
    }

    private actionsToDropDownMap() {
        let actions: DropDownModel[] = [];
        if (this.state.availableSupervisorFlowAction?.availableActions && Api.isSuccess(this.state.availableActionResponse)) {
            actions = this.state.availableSupervisorFlowAction.availableActions.map((key) => {
                return {
                    id: key,
                    name: i18n.t(`transportation.order.status.supervisorFlowActionsPopup.actions.${key}`)
                };
            });

        }
        return DropDownUtils.listToDropDownMap(actions);
    }
}
